import { BaseTextMergeContainerEditor } from "./Text/BaseTextMergeContainerEditor";
import React from "react";
import { TextEditorRegistration } from "../Utilities/RegisterTextEditor";
import { ObserveState } from "../../CommonUI/StateManagement/ObserveState";
import SegmentIcon from "@mui/icons-material/Segment";
import { RootTextElement } from "../../rule-engine-core/TextMerge/Elements/Text/RootTextElement";
import { TextMergeEditContext } from "../../rule-engine-core/TextMerge/TextMergeEditContext";
import { BaseTextMergeContainerElement } from "../../rule-engine-core/TextMerge/Elements/BaseTextMergeContainerElement";
import { BaseTextMergeElement } from "../../rule-engine-core/TextMerge/Elements/BaseTextMergeElement";
import { StyleElement } from "../../rule-engine-core/TextMerge/Elements/Text/StyleElement";
import { TextMergeType } from "../../rule-engine-core/TextMerge/TextMergeType";
import { UILabel } from "../../CommonUI/BuildlingBlocks/UILabel";
import { Box } from "@mui/material";
import { XMLAttributeEditor } from "./JSONXML/XMLAttributeEditor";
import { InlineTextEdit } from "../../CommonUI/InlineEditor/InlineTextEdit";

class RenderList {
    render: BaseTextMergeElement[] = [];
}

export class RootElementEditor extends BaseTextMergeContainerEditor<RootTextElement> {
    renderAbove(_element: BaseTextMergeContainerElement, context: TextMergeEditContext): JSX.Element | undefined {
        if (context.definition.type === TextMergeType.XML) {
            return (
                <Box
                    marginLeft={"30px"}
                    display={"flex"}
                    flexDirection={"row"}
                    alignItems={"center"}
                    justifyContent={"start"}
                    paddingBottom={"10px"}
                >
                    <UILabel>Name: </UILabel>
                    <InlineTextEdit
                        text={context.definition.rootElement.xmlRootElementName ?? ""}
                        onEdit={(v) => {
                            context.definition.rootElement.xmlRootElementName = v;
                        }}
                    />
                </Box>
            );
        }
        return <></>;
    }

    renderContent(editContext: TextMergeEditContext, _styles: object): React.ReactNode {
        if (editContext.definition.type === TextMergeType.JSON) {
            let begin = "{";
            let end = "}";
            return (
                <code>
                    <pre>
                        {begin}
                        <br />
                        {super.renderContentInternal(editContext)}
                        {end}
                    </pre>
                </code>
            );
        } else if (editContext.definition.type === TextMergeType.XML) {
            return (
                <code>
                    <pre>
                        {XMLAttributeEditor.renderXMLContainer(
                            this.editorData!,
                            editContext,
                            this.editorData!.xmlRootElementName,
                        )}
                    </pre>
                </code>
            );
        } else {
            return this.RenderTextContent(editContext);
        }
    }

    getIcon(): JSX.Element {
        return <SegmentIcon />;
    }

    private RenderTextContent(editContext: TextMergeEditContext) {
        let els = this.editorData?.elements;
        if (els) {
            let renderStuff: (RenderList | BaseTextMergeContainerElement)[] = [];

            let currentRenderList = new RenderList();

            renderStuff.push(currentRenderList);
            for (let e of els) {
                if (e instanceof BaseTextMergeContainerElement) {
                    if (e instanceof StyleElement && e.newParagraph === false) {
                        currentRenderList.render.push(e);
                    } else {
                        renderStuff.push(e);
                        currentRenderList = new RenderList();
                        renderStuff.push(currentRenderList);
                    }
                } else {
                    currentRenderList.render.push(e);
                }
            }

            return renderStuff.map((rs) => {
                if (rs instanceof RenderList) {
                    return (
                        <p key={rs.render[0]?.id + "list"}>
                            {rs.render.map((ri) => {
                                let editor = TextEditorRegistration.getExpressionByTypeName(ri.__type)?.create(ri);
                                return (
                                    <ObserveState
                                        key={ri.id}
                                        listenTo={ri}
                                        control={() => {
                                            return editor?.renderDisplay(ri, editContext);
                                        }}
                                    />
                                );
                            })}
                        </p>
                    );
                } else {
                    let editor = TextEditorRegistration.getExpressionByTypeName(rs.__type)?.create(rs);
                    return (
                        <ObserveState
                            key={rs.id}
                            listenTo={rs}
                            control={() => {
                                return editor?.renderDisplay(rs, editContext);
                            }}
                        />
                    );
                }
            });
        } else {
            return <></>;
        }
    }
}
